export default __webpack_public_path__ + "static/char-thumb-53-4cd40d54c10f97db0369e39e539bdc11.png";